import React, { Fragment, useState, useEffect, useRef } from 'react';
import cx from 'classnames';
import { Icon } from '@iconify/react';
import iconTag from '@iconify-icons/mdi/tag-outline';

const ApplyCoupon = ({ applyCoupon, cart, errorMessage, clearError }) => {
  const [couponCode, setCouponCode] = useState('');
  const [showInput, setShowInput] = useState(false);
  const prevCouponsCount = useRef(cart?.coupons?.length || 0);

  useEffect(() => {
    const currentCount = cart?.coupons?.length || 0;
    if (currentCount > prevCouponsCount.current) {
      setShowInput(false);
    }
    prevCouponsCount.current = currentCount;
  }, [cart?.coupons?.length]);

  return (
    <Fragment>
      <div className="order-recap__coupon">
        <span className="coupon-cta" onClick={() => setShowInput(!showInput)}>
          <Icon icon={iconTag} width="16" height="16" style={{ marginRight: '6px', verticalAlign: 'middle' }} />
          {app_main_wpml.have_coupon}
        </span>

        {showInput && (
          <>
            <div className="coupon-form">
              <input
                className="input-container__input"
                type="text"
                onChange={(e) => {
                  setCouponCode(e.target.value);
                  if (clearError) clearError();
                }}
                value={couponCode}
                placeholder={app_main_wpml.insertCode}
              />
              <button
                className={cx('beta-btn', 'beta-btn--m', 'btn--short')}
                onClick={(e) => {
                  e.preventDefault();
                  applyCoupon(couponCode);
                  setCouponCode('');
                }}
              >
                {app_main_wpml.apply}
              </button>
            </div>
            {errorMessage && (
              <div className="coupon-error" style={{ color: '#CC1D1D', fontSize: '12px', marginTop: '8px' }}>
                {errorMessage}
              </div>
            )}
          </>
        )}
      </div>
    </Fragment>
  );
};

export default ApplyCoupon;
